
import React, { useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from '../../API/axios'; 
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import ReportGmailerrorredSharpIcon from '@mui/icons-material/ReportGmailerrorredSharp';
import toast from 'react-hot-toast';
import { Button, Modal } from 'react-bootstrap';



const CompanyInteraction = ({ Compuid  }) => {
    const sessionId = localStorage.getItem("sessionId"); 

    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    const handleToggleDropdown = (index) => {
        setShowDropdown((prev) => (prev === index ? null : index));
    };

    //************************ Follow User Start  ************************// 

    //************************ Follow Company Start  ************************//

    const FollowCompany = async () => {
        const data = { 
            sessionId: sessionId,
            compUID: Compuid,
        };
        console.log("session ids",sessionId ,  Compuid);
        
        try {
            await axios.post("/CandidateAction/FollowCompany", data)
            .then((resData) => {
                console.log("followed", resData.data.message);
        
                toast.success(resData.data.message)
                console.log("following ");
           
            });
        } catch (e) {
            if (e.response && e.response.status === 404) { 
                toast.warning(e.response.data.message); 
            } else {
                toast.error(e.response.data.message);  
            }
        }
    };
    //************************ Follow Company End  ************************//

     //************************ Block Company Start  ************************//
     const [showModal, setShowModal] = useState(false);
     const handleShowModal = () => setShowModal(true); 

     const BlockCompany = async () => {
        const data = { 
            sessionId: sessionId,
            compUID: Compuid,
        };
        // console.log("session ids",sessionId ,Compuid);
        
        try {
            await axios.post("/CandidateAction/BlockCompany", data)
            .then((resData) => {
                console.log("Block Company", resData.data.message);
                toast.success(resData.data.message) 
                setShowModal(false)
            });
        } catch (e) {
            if (e.response && e.response.status === 404) { 
                toast.warning(e.response.data.message); 
                setShowModal(false)

            } else {
                toast.error(e.response.data.message);  
            }
        }
    };

    const handleConfirmBlock = () => {
        BlockCompany();
        setShowModal(false)
 
    };
    
    //************************ Block Company End  ************************//

     //************************ UnBlock Company Start  ************************//

     const UnBlockCompany = async () => {
        const data = { 
            sessionId: sessionId,
            compUID: Compuid,
        };
        console.log("session ids",sessionId ,  Compuid);
        
        try {
            await axios.post("/CandidateAction/UnblockCompany", data)
            .then((resData) => {
                console.log("Block Company", resData.data.message);
                toast.success(resData.data.message) 
            });
        } catch (e) {
            if (e.response && e.response.status === 404) { 
                toast.warning(e.response.data.message); 
            } else {
                toast.error(e.response.data.message);  
            }
        }
    };
    //************************ UnBlock Company End  ************************//

    //************************ UnFollow Company Start  ************************//
    const [showUnfollowModal, setshowUnfollowModal] = useState(false);
    const handleCloseModal = () => setshowUnfollowModal(false);
    const handleShow = () => setshowUnfollowModal(true); 
    const UnFollow = async () => {
        const data = { 
            sessionId: sessionId,
            compUID: Compuid,

        };
        try {
            await axios.post("/CandidateAction/UnfollowCompany", data).
            then((resData) => {
                console.log("resData", resData.data.message);
                toast.success(resData.data.message) 
                handleCloseModal();
                
            });
        } catch (e) {
            if (e.response && e.response.status === 404) {
                toast.warning(e.response.data.message);  
            } else {
                toast.error(e.response.data.message);   
            }
        }
    };

    const handleConfirmUnfollow = () => {
        UnFollow();
        setShowModal(false)
 
    };
    //************************ UnFollow Company End  ************************//

    // useEffect(() => {
    //     if (showModal) {
    //         document.body.style.overflow = 'hidden';

    //     } else {
    //         document.body.style.overflow = 'unset';

    //     }
    // }, [showModal]);
   console.log('show',showModal);

    return (
        <>
                 {/* <div className="follow "> */}
                 
                        <div className="button-readmore follow">
                        <button 
                            className="btn-employer "
                            onClick={() => {
                                FollowCompany();
                            }}
                        > Follow
                        </button>
                        </div>

                      <Dropdown>
                        <Dropdown.Toggle as="span" className="icon-togg">
                         
                          <MoreHorizSharpIcon className="ms-2" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item href="#" onClick={()=>{handleShowModal()}}>
                            Block 
                          </Dropdown.Item>
                          <Dropdown.Item href="#" onClick={UnBlockCompany}>
                            Unblock
                          </Dropdown.Item>
                          <Dropdown.Item href="#" onClick={handleShow}>
                            Unfollow
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
             

                {/* ...............block modal............  */}
            <Modal show={showModal} onHide={handleCloseModal} centered>
            <Modal.Header>
            <Modal.Title>Confirm Block</Modal.Title>
            <CloseSharpIcon className="pointer" onClick={handleCloseModal} />
            </Modal.Header>
            <Modal.Body className="settings">
            <div className=" mb-3">
                <p>Are you sure you want to block Company</p>
            </div>
            </Modal.Body>
            <Modal.Footer>
            <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Confirm</button>
            {/* <button onClick={handleClose} className="btn btn-secondary">Cancel</button> */}

            </Modal.Footer>

            </Modal>


                {/* ...............Unfollow modal............  */}

            <Modal show={showUnfollowModal} onHide={handleCloseModal} centered>
            <Modal.Header >
            <Modal.Title> Unfollow</Modal.Title>
            <CloseSharpIcon className="pointer" onClick={handleCloseModal} />
            </Modal.Header>
            <Modal.Body className="settings">
            <div className=" mb-3">
                <p>Are you sure you want to Unfollow Company</p>
            </div>
            </Modal.Body>
            <Modal.Footer>
            <button onClick={handleConfirmUnfollow} className="btn btn-danger me-2">Confirm</button>
            {/* <button onClick={handleClose} className="btn btn-secondary">Cancel</button> */}

            </Modal.Footer>

            </Modal>
        </>
    )
}

export default CompanyInteraction